<template>
<div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <div class="header">
        <div class="banner">
            <h1 class="title">
                    Vue demo
                </h1>
            <p class="description">
            </p>
        </div>
        <nav v-for="item in routers">
            <router-link :to="item.url" v-text="item.urlName"></router-link>
        </nav>
    </div>
    <div class="main-content">
        <router-view class="view"></router-view>
    </div>
    <!-- <article-list></article-list>
    <section class="base-router">
        <h1 class="title">Base-Router</h1>
        <div class="sider-bar">
            <router-link to="/first">First page</router-link>
            <router-link to="/second">Second page</router-link>
        </div>
        <div class="main-content">
            <router-view class="view"></router-view>
        </div>
    </section> -->
</div>
</template>

<script>
// import firstcomponent from './component/firstcomponent.vue'
// import secondComponent from './component/secondComponent.vue'

export default {
    name: 'app',
    data() {
        return {
            msg: 'sdf',
            articles: [],
            page:0,
            routers:[{
                urlName:'Home',
                url : '/home'
            }]
        }
    },

}
</script>
<style lang='sass'>

@mixin inlineTop {
    display: inline-block;
    vertical-align: top;
}
// section
.base-router {
    width: 80%;
    margin: 0 auto 50px;
    overflow: auto;
    .title {
        text-align: left;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
    }
    .sider-bar {
        width: 30%;
        @include inlineTop;
        a,button {
            width: 100%;
            display: block;
            margin: 10px 0 0;
            padding: 10px;
            border: 1px solid #e6e6e6;
            background: none;
        }
    }
    .main-content {
        width: 68%;
        @include inlineTop;
    }
}
// douban movie
.movie {
    @extend .base-router;
}
</style>



// WEBPACK FOOTER //
// App.vue?3c7e0b90